import React, { Fragment } from 'react'
import { Avatar, Backdrop, Box, Fade, Modal, Typography } from '@mui/material'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import FormInput from '@/components/Common/FormInput'
import AccountStatusModal from '@/components/AccountStatusModal'
import { UserInterface } from '@/services/types/APIResponseType'
import { formatPhoneNumber, stringAvatar } from '@/utils'
import close_icon from '@/assets/close_icon.svg'

interface BabysitterModelPropsType {
  consumersCount: number
  isModelOpen: boolean
  handleModelClose: () => void
  handleShowConsumersData: () => void
  handleStatusChange: (isBlocked: boolean) => void
  profileData: UserInterface | null
  showPopup: boolean
}

const BabysittersProfileModel: React.FC<BabysitterModelPropsType> = ({
  consumersCount,
  isModelOpen,
  handleModelClose,
  handleShowConsumersData,
  handleStatusChange,
  profileData,
  showPopup,
}) => {
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={isModelOpen}
      onClose={handleModelClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={isModelOpen}>
        <Box className="modal-container h-[600px]" id="main_model">
          <div className="model-close" onClick={handleModelClose}>
            <img src={close_icon} alt="Close" />
          </div>
          <Typography id="transition-modal-title" variant="h6" component="h2">
            <div className="modal-heading-content mb-2 font-bold">
              Supervisor Details
            </div>
          </Typography>
          <div className="h-[444px] overflow-auto">
            <div className="babysitter-avatar">
              {profileData?.profileInfo?.profilePic ? (
                <img alt="Profile" src={profileData?.profileInfo?.profilePic} />
              ) : (
                <Avatar
                  className="!bg-[#365F91] !h-36 !w-36 !text-5xl"
                  {...stringAvatar(
                    `${profileData?.profileInfo?.firstName || ''} ${profileData?.profileInfo?.lastName || ''}`,
                  )}
                />
              )}
            </div>
            <div className="flex flex-col">
              <div className="mx-auto grid w-full grid-cols-2 justify-items-center gap-5 md:w-[80%]">
                <FormInput
                  type="text"
                  name="firstName"
                  label="First Name"
                  value={profileData?.profileInfo?.firstName || ''}
                  readOnly={true}
                />
                <FormInput
                  type="text"
                  name="lastName"
                  label="Last Name"
                  value={profileData?.profileInfo?.lastName || ''}
                  readOnly={true}
                />
                <FormInput
                  type="email"
                  name="email"
                  label="Email Address"
                  value={profileData?.email || ''}
                  readOnly={true}
                />
                <FormInput
                  type="text"
                  name="phone"
                  label="Phone Number"
                  value={formatPhoneNumber(
                    profileData?.profileInfo?.phone || '',
                    profileData?.profileInfo?.countryCode || '',
                  )}
                  readOnly={true}
                />
                <FormInput
                  type="number"
                  name="count"
                  label="Registered participant"
                  value={consumersCount!}
                  readOnly={true}
                  onClickIcon={() => {
                    handleShowConsumersData()
                  }}
                  endIconComponent={<ChevronRightIcon />}
                />
                <Fragment>
                  <div className="bg-grad before:rounded-[57px] h-20 w-full before:!z-[-1] before:!border-[1.2px]">
                    <div className="flex flex-row w-full justify-between items-center p-[20px] px-[35px] bg-[rgb(8,12,20,0.05]">
                      <label className="text-[#7D7D7D] text-sm">Status</label>
                      <AccountStatusModal
                        isActive={!profileData?.isAccountBlocked}
                        isPopupOpen={showPopup}
                        handleApiCall={handleStatusChange}
                      />
                    </div>
                  </div>
                </Fragment>
              </div>
              <div className="model-government-id-wrapper">
                <label>Government ID</label>
                <div>
                  <img
                    alt="Front view of ID card"
                    src={`${
                      profileData?.profileInfo?.idFront
                        ? profileData?.profileInfo?.idFront
                        : '/icon/Image.svg'
                    }`}
                    draggable="false"
                  />
                  <img
                    alt="Back view of ID card"
                    src={`${
                      profileData?.profileInfo?.idBack
                        ? profileData?.profileInfo?.idBack
                        : '/icon/Image.svg'
                    }`}
                    className="govt-id-img"
                    draggable="false"
                  />
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Fade>
    </Modal>
  )
}

export default BabysittersProfileModel
